module.exports = __webpack_public_path__ + "static/img/stage3.b9ce829.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/background/stage3.png
// module id = 72CJ
// module chunks = 1